import { Controller } from "@hotwired/stimulus"
import { clearBench } from "../lib/bench_store"
import { clearHere } from "../lib/keep"

// Signing out, or deleting the account, also clears the workbench and what the tools remember from this browser, so
// a shared computer doesn't keep the shop's tools. The account keeps its own copy (or, when deleting, nothing at all).
export default class extends Controller {
  forget() {
    clearBench({ here: true })
    clearHere()
  }
}
